import React from 'react';
import PropTypes from 'prop-types';

import close from '#/assets/icons/close.svg';
import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


function SuccessFlag({ isOpen, onClose }) {
  const { t } = useTranslation();

  return (
    <div className={[styles.flag, isOpen ? styles.isOpen : ''].join(' ')}>
      <p>{t('SAVED_SUCCESSFULLY')}</p>
      <button
        className={styles.close}
        onClick={onClose}
        data-testid="close-button-notification"
      >
        <img src={close} alt={t('CLOSE_ICON')} />
      </button>
    </div>
  );
}

SuccessFlag.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SuccessFlag;
